import { apiSlice } from './apiSlice';

export const gameDataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGameData: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = '',
        sort = 'GameDate',
        order = 'desc',
      }) => ({
        url: 'games',
        params: { page, limit, search, sort, order },
      }),
      transformResponse: (response) => ({
        entries: response.entries || [],
        total: response.total || 0,
        page: response.page || 1,
        pages: response.pages || 1,
      }),
      providesTags: (result) =>
        Array.isArray(result?.entries)
          ? [
              ...result.entries.map((entry) => ({
                type: 'GameData',
                id: entry._id,
              })),
              { type: 'GameData', id: 'LIST' },
            ]
          : [{ type: 'GameData', id: 'LIST' }],
    }),

    createGameData: builder.mutation({
      query: (data) => ({
        url: 'games',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'GameData', id: 'LIST' }],
    }),

    updateGameData: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `games/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: [{ type: 'GameData', id: 'LIST' }],
    }),

    deleteGameData: builder.mutation({
      query: (id) => ({
        url: `games/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'GameData', id: 'LIST' }],
    }),

    uploadGameCSV: builder.mutation({
      query: (formData) => ({
        url: 'games/uploadGame',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: [
        { type: 'GameData', id: 'LIST' },
        { type: 'ShotData', id: 'LIST' },
      ],
    }),

    getGamesByPlayer: builder.query({
      query: ({
        playerName,
        page = 1,
        limit = 10,
        search = '',
        sort = 'GameDate',
        order = 'desc',
      }) => ({
        url: `games/player/${playerName}`,
        params: { page, limit, search, sort, order },
      }),
      transformResponse: (response) => ({
        entries: response.entries || [],
        total: response.total || 0,
        page: response.page || 1,
        pages: response.pages || 1,
      }),
      providesTags: (result) =>
        Array.isArray(result?.entries)
          ? [
              ...result.entries.map((entry) => ({
                type: 'GameData',
                id: entry._id,
              })),
              { type: 'GameData', id: 'LIST' },
            ]
          : [{ type: 'GameData', id: 'LIST' }],
    }),

    getPlayerGameShots: builder.query({
      query: ({
        gameId,
        playerName,
        page = 1,
        limit = 10,
        sort = 'gameTimeSeconds',
        order = 'asc',
      }) => ({
        url: `games/${gameId}/player/${playerName}/shots`,
        params: { page, limit, sort, order },
      }),
      transformResponse: (response) => response.entries || [],
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map((entry) => ({
                type: 'GameData',
                id: entry._id,
              })),
              { type: 'GameData', id: 'SHOTS' },
            ]
          : [{ type: 'GameData', id: 'SHOTS' }],
    }),
  }),
});

export const {
  useGetGameDataQuery,
  useCreateGameDataMutation,
  useUpdateGameDataMutation,
  useDeleteGameDataMutation,
  useUploadGameCSVMutation,
  useGetGamesByPlayerQuery,
  useGetPlayerGameShotsQuery,
} = gameDataApiSlice;
